export default "__VITE_ASSET__D0rKsivt__"